// extracted by mini-css-extract-plugin
module.exports = {"skillIcon":"skill-item-module--skillIcon--1fdYM","secondary":"skill-item-module--secondary--3FHms"};